import React from "react";
import NumberDisplay from "./NumberDisplay";
import {Lot} from "@nextlot/core/webcast/data/data_types_definitions";
import {RoundTypeEnum} from "@nextlot/core/webcast/data/WebcastDataDomain";
import {useAppSelector} from "@nextlot/core/webcast/hooks";


export default function ClerkCurrentRoundHighestOnlineBidsCmp() {

    const firstOnlineBid = useAppSelector((state) => state.activeWebcast.webcastCurrentRoundBidding.firstOnlineBid);
    const secondOnlineBid = useAppSelector((state) => state.activeWebcast.webcastCurrentRoundBidding.secondOnlineBid);
    const currentRound = useAppSelector((state) => state.activeWebcast.webcastCurrentRound);
    const lotsMapById = useAppSelector((state) => state.activeWebcast.webcastAuctionData.lotsMapById);
    const highestBid = useAppSelector((state) => state.activeWebcast.webcastCurrentRoundBidding.highestBid);

    if (! firstOnlineBid) {
        return null;
    }

    let groupChoiceRoundHighOnlineBidderLots:Array<Lot> = null;

    // if the currentRound is stopped, and it's a CHOICE round
    if (currentRound.stopType && currentRound.roundType === RoundTypeEnum.GROUP_CHOICE) {
        // show the lots where the highest PreBidder is highest
        groupChoiceRoundHighOnlineBidderLots = currentRound.lotsIds
            .map(lotId => lotsMapById.get(lotId))
            // filter just lots where leadPreBid is the round firstPrebid.participantId
            .filter(lot => lot.leadingOnlineBid && lot.leadingOnlineBid.userId === firstOnlineBid.userId)
    }

    return (
        <div className="card mt-1">
            <div className="card-body py-2 px-3">
                <h6 className="card-title text-body-secondary">Round highest online bids received</h6>
                <div className="">
                    <div>
                        <div className='fw-bold'>
                            <mark style={{fontSize: '1.25rem', backgroundColor: highestBid == undefined || firstOnlineBid.maximumValue > highestBid.value ? 'lime' : 'salmon'}}>{firstOnlineBid.bidderDisplay}</mark>
                        </div>
                        <div>&nbsp;&raquo; <mark style={{fontSize: '1.25rem', backgroundColor: highestBid == undefined || firstOnlineBid.maximumValue > highestBid.value ? 'lime' : 'salmon'}}>max <strong>{NumberDisplay.formatValueCents(firstOnlineBid.maximumValue)}</strong></mark>
                            &nbsp;|&nbsp;
                            {
                                (firstOnlineBid.isSecret)
                                    ? <span>absentee</span>
                                    : <strong>{NumberDisplay.formatValueCents(firstOnlineBid.value)}</strong>
                            }
                        </div>
                        {
                            groupChoiceRoundHighOnlineBidderLots
                            &&
                            <div className="">
                                <div>Lots with highest online bid</div>
                                <ul>
                                    {
                                        groupChoiceRoundHighOnlineBidderLots.map(lot => {
                                            return (
                                                <li key={lot.id}>
                                                    <strong>{lot.number}</strong> &raquo; max {NumberDisplay.formatValueCents(lot.leadingOnlineBid.maximumValue)}
                                                </li>
                                            )
                                        })
                                    }
                                </ul>
                            </div>
                        }
                    </div>
                    {
                        (! groupChoiceRoundHighOnlineBidderLots && secondOnlineBid)
                        &&
                        <div className="pt-3">
                            <div className='fw-bold'>{secondOnlineBid.bidderDisplay}</div>
                            <div>&nbsp;&raquo; max <strong>{NumberDisplay.formatValueCents(secondOnlineBid.maximumValue)}</strong>
                            </div>
                        </div>
                    }
                </div>
            </div>
        </div>
    )
}






